import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["size", "color", "alignWithText", "aria-label", "id"];
// THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY.

import { useTheme } from 'foundations-theming/utils';
import { isCanvasTheme } from 'foundations-theming/utils';
import { useIconSize } from 'foundations-assets/icons/useIconSize';
import { StyledIcon } from 'foundations-assets/icons/StyledIcon';
import { getDataProps } from 'foundations-assets/icons/getDataProps';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const StopRecordIcon = _ref => {
  let {
      size: sizeProp,
      // We don't set the default value here because we want to know if a consumer passed in a value
      color: colorProp,
      // We don't set the default value here because we want to know if a consumer passed in a value
      alignWithText = false,
      'aria-label': ariaLabel,
      id
    } = _ref,
    restProps = _objectWithoutPropertiesLoose(_ref, _excluded);
  const theme = useTheme();
  const dataProps = getDataProps(restProps);
  const isCanvas = isCanvasTheme(theme);

  // Setting default values here
  const size = sizeProp !== null && sizeProp !== void 0 ? sizeProp : 'inherit';
  const color = colorProp !== null && colorProp !== void 0 ? colorProp : 'inherit';
  const sizeValue = useIconSize(size);
  const sizeCSSValue = sizeProp ? `${sizeValue} !important` : sizeValue; // Adds the `!important` flag to the `size` value if one is provided via props

  const colorValue = color === 'inherit' ? 'currentColor' : theme.color[color]; // inherit = currentColor = text color of the parent element
  const colorCSSValue = colorProp ? `${colorValue} !important` : colorValue; // Adds the `!important` flag to the `color` value if one is provided via props

  return /*#__PURE__*/_jsx(StyledIcon, Object.assign({}, dataProps, {
    $size: sizeCSSValue,
    $color: colorCSSValue,
    $alignWithText: alignWithText,
    "aria-label": ariaLabel,
    "aria-hidden": ariaLabel === undefined ? true : undefined,
    id: id,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    focusable: "false",
    "data-icon-name": "StopRecord",
    children: isCanvas ? /*#__PURE__*/_jsx(_Fragment, {
      children: /*#__PURE__*/_jsx("path", {
        d: "M9.5 15.81v-2.18c0-.83-.67-1.5-1.5-1.5s-1.5.67-1.5 1.5v1.78c0 1.05.18 2.05.5 2.99l-.02-.07 2.53-2.52ZM20.23 5.07C19.61 3.27 17.94 2 15.97 2a4.5 4.5 0 0 0-4.5 4.5v7.32l8.76-8.76Zm2.2 11.22c-.41 2.9-2.68 5.17-5.54 5.57h-.03l-2.81 2.84.47.1v2.25h-2.83l-2.65 2.61c.26.22.59.35.96.35h12.01c.83 0 1.5-.67 1.5-1.5s-.67-1.5-1.5-1.5H17.5V24.8c4.56-.75 8-4.67 8.01-9.38v-1.77c0-.13-.02-.26-.05-.38s-3.02 3.04-3.02 3.04Zm3.4-12.99L3.28 25.85c-.38.37-.62.89-.62 1.46s.24 1.09.62 1.46c.37.38.89.62 1.46.62s1.09-.24 1.46-.62L28.72 6.18c.38-.37.62-.89.62-1.46s-.24-1.09-.62-1.46c-.37-.36-.87-.58-1.43-.58s-1.09.24-1.46.62"
      })
    }) : /*#__PURE__*/_jsxs(_Fragment, {
      children: [/*#__PURE__*/_jsx("path", {
        d: "M24.06 18.12c-.14 0-.29-.03-.43-.08-.58-.24-.87-.9-.63-1.49.38-.95.58-1.95.58-2.98a1.14 1.14 0 1 1 2.28 0c0 1.33-.25 2.62-.74 3.84-.18.45-.61.72-1.06.72ZM15.57 23.86c-5.67 0-10.29-4.61-10.29-10.29a1.14 1.14 0 1 1 2.28 0c0 4.41 3.59 8 8 8a1.14 1.14 0 1 1 0 2.28ZM20.14 14.71c-.63 0-1.14-.51-1.14-1.14v-8c0-1.89-1.54-3.43-3.43-3.43-1.57 0-2.93 1.06-3.32 2.57a1.14 1.14 0 1 1-2.21-.57 5.704 5.704 0 0 1 5.53-4.28c3.15 0 5.71 2.56 5.71 5.71v8c0 .63-.51 1.14-1.14 1.14"
      }), /*#__PURE__*/_jsx("path", {
        d: "M15.57 31.86c-.63 0-1.14-.51-1.14-1.14v-8a1.14 1.14 0 1 1 2.28 0v8c0 .63-.51 1.14-1.14 1.14"
      }), /*#__PURE__*/_jsx("path", {
        d: "M21.29 31.86H9.86a1.14 1.14 0 1 1 0-2.28h11.43a1.14 1.14 0 1 1 0 2.28M28.14 29.57c-.29 0-.58-.11-.81-.33L2.19 4.09a1.14 1.14 0 0 1 0-1.62 1.14 1.14 0 0 1 1.62 0l25.14 25.14a1.14 1.14 0 0 1-.81 1.95Z"
      })]
    })
  }));
};
StopRecordIcon.displayName = 'StopRecordIcon';